export const ADD_POST = 'addPost';
export const ADD_POSTS = 'addPosts';
export const REPLACE_POST = 'replacePost';
export const DELETE_POST = 'deletePost';
export const TOGGLE_READ_STATE = 'toggleReadState';
export const MARK_AS_READ = 'markAsRead';
export const MARK_AS_UNREAD = 'markAsUnread';
export const ADD_COMMENT = 'addComment';
export const REMOVE_COMMENT = 'removeComment';
